export const statusDropdown = [
    {
      label: "Active",
      value: "ACTIVE",
    },
    {
      label: "Inactive",
      value: "INACTIVE",
    },
  ];

 export  const MODULE_MASTER_TYPE = [
    {
      label: "Receipt Accounting",
      value: "RECEIPT_ACCOUNTING",
    },
    {
      label: "Refund Accounting",
      value: "REFUND_ACCOUNTING",
    },
    {
      label: "Deposition Accounting",
      value: "DEPOSITION_ACCOUNTING",
    },
    {
      label: "Invoice Accounting",
      value: "INVOICE_ACCOUNTING",
    },
  ];

  export const  MODULE_MASTER_LABEL_VALUE_MAP= {
    RECEIPT_ACCOUNTING: "Receipt Accounting",
    REFUND_ACCOUNTING: "Refund Accounting",
    DEPOSITION_ACCOUNTING: "Deposition Accounting",
    INVOICE_ACCOUNTING: "Invoice Accounting",
  }
